import React from 'react';
import { FiShield, FiCheckCircle, FiFileText, FiBarChart, FiLock } from 'react-icons/fi';

const FEATURES = [
  {
    icon: <FiShield className="text-[#0077b5] text-lg" />,
    iconBg: 'bg-[#0077b5]/10',
    title: 'Security posture sharing',
    body: (
      <>
        Share certifications, audit reports, and security policies with customers in seconds — with controlled access and <span className="text-[#0077b5]">full</span> audit logging.
      </>
    ),
  },
  {
    icon: <FiCheckCircle className="text-[#ff6600] text-lg" />,
    iconBg: 'bg-[#ff6600]/10',
    title: 'Questionnaire automation',
    body: 'Auto-fill and manage security questionnaires so your team never starts from a blank page again. Smart answer reuse across requests.',
  },
  {
    icon: <FiFileText className="text-[#0077b5] text-lg" />,
    iconBg: 'bg-[#0077b5]/10',
    title: 'NDA management',
    body: 'Streamline the NDA request, review, and e-signature process between your legal team and prospective customers.',
  },
  {
    icon: <FiBarChart className="text-[#ff6600] text-lg" />,
    iconBg: 'bg-[#ff6600]/10',
    title: 'Full audit trail',
    body: (
      <>
        Every request, document access, and response is timestamped and logged — giving you <span className="text-[#0077b5]">complete</span> accountability for every interaction.
      </>
    ),
  },
  {
    icon: <FiBarChart className="text-[#0077b5] text-lg" />,
    iconBg: 'bg-[#0077b5]/10',
    title: 'Real-time status dashboard',
    body: 'Both you and your customers get live dashboards showing request status, resolution timelines, and outstanding items.',
  },
  {
    icon: <FiLock className="text-[#ff6600] text-lg" />,
    iconBg: 'bg-[#ff6600]/10',
    title: 'Branded trust portal',
    body: 'A fully white-labeled portal that matches your brand — your customers experience your identity, powered by our infrastructure.',
  },
];

const RequesterFeatures = () => (
  <section className="py-24 bg-[#919191]/5">
    <div className="max-w-screen-2xl mx-auto px-10">

      {/* Header */}
      <div className="text-center mb-14">
        <div className="inline-block border border-[#919191] text-[#919191] text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5">
          Platform Capabilities
        </div>
        <h2 className="text-4xl font-extrabold text-[#53545a] mb-4">Everything your trust center needs</h2>
        <p className="text-[#919191] text-base max-w-md mx-auto leading-relaxed">
          Purpose-built tools for managing the full trust relationship lifecycle between your organization and your customers.
        </p>
      </div>

      {/* Cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {FEATURES.map((f) => (
          <div key={f.title} className="bg-white p-7 hover:shadow-md transition-shadow">
            <div className={`w-10 h-10 ${f.iconBg} flex items-center justify-center mb-5`}>
              {f.icon}
            </div>
            <h3 className="font-bold text-[#53545a] text-base mb-2">{f.title}</h3>
            <p className="text-[#919191] text-sm leading-relaxed">{f.body}</p>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default RequesterFeatures;
